import { FC, PropsWithChildren } from "react";

export const SectionsContainer: FC<PropsWithChildren> = ({ children }) => {
  return (
    <group
      //data-max-length="1440"
      data-gap="40"
      data-direction="column"
      data-space="10"
      data-position="center"
      data-space-vertical="30"
    >
      {children}
    </group>
  );
};
